import { useEffect, useState } from "react";
import "./Dashboard.css";
import { useLanguage } from '../../../utils/languageContext';
import "./Modal.css";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios
import QRCodeScanner from "./QRCodeScanner";
import { AbhaSendOtp } from "./AbhaSendOtp";
import { AbhaVerifyOtp } from "./AbhaVerifyOtp";
import Modalqr from "./Modalqr";
import ModernSpeedometer from "./ModernSpeedometer";
import ReactSpeedometer from "react-d3-speedometer";
import { encryptString, createSession, getAbhaProfile, verifyUser } from "../../../utils/apiUtils";
import { v4 as uuidv4 } from 'uuid';
import { handleGetRefreshToken } from "../../sickle/components/Sickleform";
import { Addbenificerymodal } from "./Addbenificerymodal";
import Loader from '../../../components/Loader';
import "./DashboardHeader.css";
import Footer from "../../../components/Footer";
import BeneficiaryCard from "../components/Dashboard/BeneficiaryCard";
import SpeedometerCard from "../components/Dashboard/SpeedometerCard";
import NcdModernDashboard from "../components/Dashboard/NcdModernDashboard";
import { ncdAPI } from '../../../services/ncd.api';
import AbdmSection from "./AbdmSection/AbdmSection";
import { pmndpAPI } from '../../../services/pmndp.api';
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { CollectionsOutlined } from "@mui/icons-material";

export const Dashboard = () => {
    const { t } = useLanguage();
    const [AbhaTxnId, setAbhaTxnId] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showOtpModal, setOtpModal] = useState(false);
    const [showDataModal, setShowDataModal] = useState(false);
    const [abhano, setabhano] = useState("");
    const [displayValue, setDisplayValue] = useState("");
    const [abdmAbhaOtp, setotp] = useState(new Array(6).fill(""));
    const [OtpText, setOtpText] = useState("");
    const [beneficiaryData, setBeneficiaryData] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [txnId, settxnId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isExistBeneficiary, setExistBeneficiary] = useState(false);
    const [resendTimer, setResendTimer] = useState(0); // Timer starts from 30 seconds
    const [showScannerModal, setshowScannerModal] = useState(false);
    const [isqrenabled, setisqrenabled] = useState(false);
    const [showAbhaSendOtp, setshowAbhaSendOtp] = useState(false);
    const [showAbhaVerifyOtp, setshowAbhaVerifyOtp] = useState(false);
    const [accessToken, setaccessToken] = useState("");
    const [abhaEncrpt, setAbhaEncrpt] = useState("");
    const [mobileEncrpt, setMobileEncrpt] = useState("");
    const [totalSickleReg, settotalSickleReg] = useState(0);
    const [addbenificeryModal, setAddbenificeryModal] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [searchBy, setSearchBy] = useState("mobile");
    const [MobileNumber, setMobileNumber] = useState("");
    const [dashboardData, setDashboardData] = useState(null);
    const [pmndpDashboardData, setPmndpDashboardData] = useState(null);
    const location = useLocation();

    const openModal = () => { setShowModal(false); setAddbenificeryModal(true); }
    useEffect(() => {
        if (location.state?.openAddBeneficiary) {
            setAddbenificeryModal(true);
        }
    }, [location.state]);
    const openSendOtpModal = () => {
        setShowModal(false);
        setDisplayValue("");
        setabhano("");
        setshowAbhaSendOtp(true);
        setAddbenificeryModal(false);
    }

    const closeSendOtpModal = () => {
        setshowAbhaSendOtp(false);
        //setshowAbhaVerifyOtp(true);
        setshowAbhaVerifyOtp(false);

    }

    const closeVerifyOtpModal = () => setshowAbhaVerifyOtp(false);

    /**
     * This handl request
     */
    const openScannerModal = () => {
        setisqrenabled(true);
        setshowScannerModal(true);
        setShowModal(false);
        setAddbenificeryModal(false);
    }

    const closeScannerModal = () => {
        setshowScannerModal(false);
        setisqrenabled(false);
    };

    // const closeOtpModal = () => {
    //     setOtpModal(false);
    //     setotp(new Array(6).fill(""));
    //     setOtpText("");
    // };

    // const maskNumber = (num) => {
    //     // Split the number into parts based on the delimiter '-'
    //     const parts = num.split("-");
    //     // Mask all but the last group
    //     const maskedParts = parts.map((part, index) =>
    //         index === parts.length - 1 ? part : part.replace(/./g, "X")
    //     );
    //     // Join the parts back with the delimiter
    //     return maskedParts.join("-");
    // };

    const navigate = useNavigate(); // React Router hook for navigation

    useEffect(() => {
        // Check if token exists in local storage
        const token = localStorage.getItem("SKT_token") || localStorage.getItem("NCD_token") || localStorage.getItem("sickle_token") || localStorage.getItem("PMNDP_token") || localStorage.getItem("NIKSHAY_valid_user") || localStorage.getItem("uwin_token") || localStorage.getItem("JANANI_token") || localStorage.getItem("RBSK_token") || localStorage.getItem("e-OPD_token");
        if (token) {
            // Token exists, redirect to dashboard
            navigate("/dashboard");
        } else {
            navigate("/login");
        }

        if (localStorage.getItem("NCD_loggedinUserdetails")) {
           fetchDashboardData();
        }

        if (localStorage.getItem("SICKLE_loggedinUserdetails")) {
            getSickleCount();
        }

    }, [navigate]); // run on mount

    useEffect(() => {
        if (localStorage.getItem("beneficiaryDetails")) {
            setExistBeneficiary(true);
        }

        if (localStorage.getItem("PMNDP_loggedinUserdetails")) {
            getpmndpDashboardCount();
        }

    }, [])

    // Countdown logic using useEffect
    useEffect(() => {
        if (resendTimer > 0) {
            const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
            return () => clearTimeout(timer); // Cleanup timer on unmount
        }
    }, [resendTimer]);

    // const closeDataModal = () => {
    //     setShowDataModal(false);
    //     setBeneficiaryData(null);
    // };


    const getpmndpDashboardCount = async () => {
        try {
            const pmndpUserDetails = JSON.parse(localStorage.getItem("PMNDP_loggedinUserdetails"));
            if (pmndpUserDetails?.facilityTypeId) {
                const response = await pmndpAPI.getDashboardCount({ facilityId: pmndpUserDetails.facilityTypeId });
                if (response.success) {
                    setPmndpDashboardData(response.data?.data?.mobileGet);
                }
            }
        } catch (error) {
            console.error('Error fetching PMNDP dashboard count:', error);
        }
    };

    const getSickleCount = async () => {
        try {

            const loggedinUserdetails = JSON.parse(localStorage.getItem("loggedinUserdetails"));

            if (loggedinUserdetails && loggedinUserdetails.InchargeMobile) {

                const sickleRefreshTokenData = await handleGetRefreshToken(localStorage.getItem("sickle_refresh_token"));

                const response = await axios.post(
                    'sickle2staging/Master_data2/totalRegistration',
                    { "InchargeMobile": loggedinUserdetails.InchargeMobile },
                    {
                        headers: {
                            Authorization: `Bearer ${sickleRefreshTokenData.result?.token}`,
                        },
                    }
                );

                settotalSickleReg(response?.data?.Result?.total_registered || 0);

            }

        } catch (error) {
            console.log(error);
        }
    }

    const fetchDashboardData = async (customParams = {}) => {
        try {
            const loggedinUserdetails = JSON.parse(localStorage.getItem("NCD_loggedinUserdetails")) || {};
            const facilityType = loggedinUserdetails?.facilityType || '';

            let stateId = 'all';
            let districtId = 'all';
            let talukaId = 'all';
            let phcId = 'all';
            let subcenterId = 'all';
            let villageId = 'all';
            let locationTypeId = loggedinUserdetails?.facility || '';

            if (facilityType === 'PHC') {
                stateId = 'all';
                districtId = 'all';
                phcId = loggedinUserdetails?.facility || 'all';
            } else if (facilityType === 'CHC' || facilityType === 'DH') {
                stateId = 'all';
                districtId = loggedinUserdetails?.facility || 'all';
            } else if (facilityType === 'SUBCENTER') {
                stateId = 'all';
                districtId = 'all';
                talukaId = 'all';
                phcId = 'all';
                subcenterId = loggedinUserdetails?.facility;
                villageId = 'all';
            } else {
                stateId = 'all';
                districtId = loggedinUserdetails?.facility || 'all';
            }

            const input = {
                section: 'ncd_program_analysis',
                view: 'reporting',
                chart: 'mo_dashboard_data',
                locationType: facilityType,
                locationTypeId: locationTypeId,
                stateId: stateId,
                districtId: districtId,
                talukaId: talukaId,
                phcId: phcId,
                subcenterId: subcenterId,
                villageId: villageId,
                ...customParams
            };

            const resp = await ncdAPI.getDashboardData(input);

            if (resp?.success && resp?.data) {
                setDashboardData(Array.isArray(resp.data) ? resp.data[0] : resp.data);
            }

        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        }
    }

    // const handleRedirect = () => {
    //     navigate("/detailsabha"); // Redirect to the Detailsabha page
    // };

    const handleNavigateBeneficiary = () => {
        navigate("/detailsabha"); // Redirect to the Detailsabha page
    }

    // const handleRadioInput = (e) => {
    //     const inputValue = e.target.value;
    //     setSearchBy(inputValue);
    //     setDisplayValue("");
    //     setabhano("");
    //     setMobileNumber("");
    //     setAbhaEncrpt("");
    //     setMobileEncrpt("");
    //     setaccessToken("");
    // };

    // const handleInputChange = (e) => {
    //     const inputValue = e.target.value;

    //     // Remove non-numeric characters
    //     const numericValue = inputValue.replace(/\D/g, "");

    //     // Format the value as xx-xxxx-xxxx-xxxx
    //     const formattedValue = numericValue.replace(
    //         /^(\d{2})(\d{0,4})(\d{0,4})(\d{0,4}).*/,
    //         (match, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-")
    //     );

    //     // Update state
    //     setDisplayValue(formattedValue);
    //     setabhano(numericValue);
    // };

    // const handleMobileChange = (e) => {
    //     const inputValue = e.target.value;

    //     // Remove non-numeric characters
    //     const numericValue = inputValue.replace(/\D/g, "");

    //     // Format the value as xx-xxxx-xxxx-xxxx
    //     const formattedValue = numericValue.replace(
    //         /^(\d{0,4})(\d{0,3})(\d{0,3}).*/,
    //         (match, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-")
    //     );

    //     // Update state

    //     // setDisplayValue(formattedValue);

    //     setDisplayValue(numericValue);

    //     setMobileNumber(numericValue);
    // };

    const sendProfileOtpRequest = async (encryptedAbha) => {
        const Backend_token = localStorage.getItem('Backend_token');
        try {
            const response = await axios.post(
                '/abdm/profileSendOtp',
                {
                    request: {
                        "scope": [
                            "abha-login",
                            "aadhaar-verify"
                        ],
                        "loginHint": "abha-number",
                        "loginId": encryptedAbha,
                        "otpSystem": "aadhaar"
                    },
                    header: {
                        'Content-Type': 'application/json',
                        'REQUEST-ID': uuidv4(),
                        'TIMESTAMP': new Date().toISOString(), // Generate the current timestamp dynamically
                        'Authorization': `Bearer ${accessToken}`,
                    },
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Backend_token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Server responded with a status:", error.response.status);
                console.error("Response data:", error.response.data);
            } else if (error.request) {
                console.error("Request was made, but no response received:", error.request);
            } else {
                console.error("Error in setting up the request:", error.message);
            }
        }

    };

    const sendMobileOtpRequest = async (mobileEncrpt) => {
        const Backend_token = localStorage.getItem('Backend_token');
        try {
            const response = await axios.post(
                '/abdm/profileSendOtp',
                {
                    request: {
                        "scope": [
                            "abha-login",
                            "mobile-verify"
                        ],
                        "loginHint": "mobile",
                        "loginId": mobileEncrpt,
                        "otpSystem": "abdm"
                    },
                    header: {
                        'Content-Type': 'application/json',
                        'REQUEST-ID': uuidv4(),
                        'TIMESTAMP': new Date().toISOString(), // Generate the current timestamp dynamically
                        'Authorization': `Bearer ${accessToken}`,
                    },
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Backend_token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Server responded with a status:", error.response.status);
                console.error("Response data:", error.response.data);
            } else if (error.request) {
                console.error("Request was made, but no response received:", error.request);
            } else {
                console.error("Error in setting up the request:", error.message);
            }
        }

    };

    // Trigger when accessToken changes
    // useEffect(() => {
    //     const sendOtpIfReady = async () => {
    //         if (accessToken && abhaEncrpt) {
    //             try {
    //                 const response = await sendProfileOtpRequest(abhaEncrpt);
    //                 if (response?.txnId) {
    //                     settxnId(response.txnId);
    //                     setAddbenificeryModal(false);
    //                     setOtpModal(true);
    //                     setIsLoading(false);
    //                     setResendTimer(60); // Example: 60 seconds
    //                 } else {
    //                     setIsLoading(false);
    //                 }
    //             } catch (error) {
    //                 setErrorMessage("Something went wrong!!");
    //                 setIsLoading(false);
    //             } finally {
    //                 setIsLoading(false);
    //             }
    //         }
    //     };
    //     sendOtpIfReady();
    // }, [accessToken, abhaEncrpt]);

    // // Trigger when accessToken changes
    // useEffect(() => {
    //     const sendOtpIfReady = async () => {
    //         if (accessToken && mobileEncrpt) {
    //             try {
    //                 const response = await sendMobileOtpRequest(mobileEncrpt);

    //                 if (response?.txnId) {
    //                     settxnId(response.txnId);
    //                     setAddbenificeryModal(false);
    //                     setOtpModal(true);
    //                     setIsLoading(false);
    //                     setResendTimer(60); // Example: 60 seconds
    //                 } else {
    //                     setIsLoading(false);
    //                     toast.error(response?.message || "Failed to send OTP. Please try again.", {
    //                         className: "custom-toast-error"
    //                     });
    //                 }
    //             } catch (error) {
    //                 setErrorMessage("Something went wrong!!");
    //                 setIsLoading(false);
    //             } finally {
    //                 setIsLoading(false);
    //             }
    //         }
    //     };
    //     sendOtpIfReady();

    // }, [accessToken, mobileEncrpt]);


    useEffect(() => {
        const sendOtpIfReady = async () => {
            if (!accessToken) return;

            setIsLoading(true);

            try {
                let response;

                if (abhaEncrpt) {
                    response = await sendProfileOtpRequest(abhaEncrpt);
                } else if (mobileEncrpt) {
                    response = await sendMobileOtpRequest(mobileEncrpt);
                } else {
                    return;
                }

                if (response?.txnId) {
                    settxnId(response.txnId);
                    setAddbenificeryModal(false);
                    setOtpModal(true);
                    setResendTimer(60);
                    toast.success(response?.message || "OTP sent successfully.");
                } else {
                    toast.error(
                        response?.message || "Failed to send OTP. Please try again.",
                        { className: "custom-toast-error" }
                    );
                }
            } catch (error) {
                setErrorMessage("Something went wrong!!");
            } finally {
                setIsLoading(false);
            }
        };

        sendOtpIfReady();
    }, [accessToken, abhaEncrpt, mobileEncrpt]);


    // const handleSearch = async (event) => {
    //     event.preventDefault();
    //     setIsLoading(true);
    //     try {
    //         if (searchBy === 'mobile') {
    //             // Encrypt Aadhaar
    //             const encryptedMobileno = await encryptString(MobileNumber);
    //             if (!encryptedMobileno) {
    //                 setIsLoading(false);
    //                 setErrorMessage("Failed to encrypt mobile. Please try again.");
    //                 return;
    //             }
    //             setMobileEncrpt(encryptedMobileno); // Update state

    //             // Create session
    //             const sessionResponse = await createSession();
    //             if (!sessionResponse?.accessToken) {
    //                 setIsLoading(false);
    //                 setErrorMessage(sessionResponse?.error?.message || "Failed to create session.");
    //                 return;
    //             }
    //             setaccessToken(sessionResponse.accessToken); // Update state
    //         } else if (searchBy === 'abha') {
    //             // Encrypt Aadhaar
    //             const encryptedAbhano = await encryptString(displayValue);
    //             if (!encryptedAbhano) {
    //                 setIsLoading(false);
    //                 setErrorMessage("Failed to encrypt Aadhaar. Please try again.");
    //                 return;
    //             }
    //             setAbhaEncrpt(encryptedAbhano); // Update state

    //             // Create session
    //             const sessionResponse = await createSession();
    //             if (!sessionResponse?.accessToken) {
    //                 setIsLoading(false);
    //                 setErrorMessage(sessionResponse?.error?.message || "Failed to create session.");
    //                 return;
    //             }
    //             setaccessToken(sessionResponse.accessToken); // Update state
    //         }

    //     } catch (error) {
    //         setIsLoading(false);
    //         setErrorMessage("An unexpected error occurred. Please try again.");
    //         console.error(error);
    //     }
    // };

    // const resendOtp = async () => {
    //     if (accessToken && abhaEncrpt) {
    //         try {
    //             const response = await sendProfileOtpRequest(abhaEncrpt);
    //             if (response?.txnId) {
    //                 settxnId(response.txnId);
    //                 setShowModal(false);
    //                 setOtpModal(true);
    //                 setIsLoading(false);
    //                 setResendTimer(60); // Example: 60 seconds
    //             } else {
    //                 setIsLoading(false);
    //             }
    //         } catch (error) {
    //             setErrorMessage("Something went wrong!!");
    //             setIsLoading(false);
    //         } finally {
    //             setIsLoading(false);
    //         }
    //     } if (accessToken && mobileEncrpt) {
    //         try {
    //             const response = await sendMobileOtpRequest(mobileEncrpt);
    //             if (response?.txnId) {
    //                 settxnId(response.txnId);
    //                 setShowModal(false);
    //                 setOtpModal(true);
    //                 setIsLoading(false);
    //                 setResendTimer(60); // Example: 60 seconds
    //             } else {
    //                 setIsLoading(false);
    //             }
    //         } catch (error) {
    //             setErrorMessage("Something went wrong!!");
    //             setIsLoading(false);
    //         } finally {
    //             setIsLoading(false);
    //         }
    //     }
    // };

    // const handleChange = (value, index) => {
    //     if (!/^\d*$/.test(value)) return; // Allow only numeric values

    //     const newOtp = [...abdmAbhaOtp];
    //     newOtp[index] = value;

    //     setotp(newOtp);

    //     // Convert OTP array to text and set it to OtpText
    //     const otpAsText = newOtp.join(""); // Joins all the digits into a single string
    //     setOtpText(otpAsText);

    //     // Automatically move to the next input field
    //     if (value && index < 5) {
    //         document.getElementById(`botp-input-${index + 1}`).focus();
    //     }
    // };

    // const handleBackspace = (e, index) => {
    //     if (e.key === "Backspace" && !abdmAbhaOtp[index] && index > 0) {
    //         document.getElementById(`botp-input-${index - 1}`).focus();
    //     }
    // };

    // const verifyMobileOtp = async (event) => {
    //     const Backend_token = localStorage.getItem('Backend_token');
    //     event.preventDefault();
    //     setIsLoading(true);
    //     try {
    //         const encryptedOtp = await encryptString(OtpText);
    //         if (encryptedOtp) {
    //             const response = await axios.post(
    //                 '/abdm/profileVerifyOtp',
    //                 {
    //                     request: {
    //                         "scope": [
    //                             "abha-login",
    //                             "mobile-verify"
    //                         ],
    //                         "authData": {
    //                             "authMethods": [
    //                                 "otp"
    //                             ],
    //                             "otp": {
    //                                 "txnId": txnId,
    //                                 "otpValue": encryptedOtp
    //                             }
    //                         }
    //                     },
    //                     header: {
    //                         'Content-Type': 'application/json',
    //                         'REQUEST-ID': uuidv4(),
    //                         'TIMESTAMP': new Date().toISOString(), // Generate the current timestamp dynamically
    //                         'Authorization': `Bearer ${accessToken}`,
    //                     },
    //                 },
    //                 {
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                         'Authorization': `Bearer ${Backend_token}`,
    //                     },
    //                 }
    //             );
    //             if (response.data?.token) {
    //                 const verifyUserObj = await verifyUser(accessToken, response.data.token, response.data.accounts[0].ABHANumber, response.data.txnId);
    //                 if (verifyUserObj.token) {
    //                     // get ABHA profile data
    //                     const abhaProfileData = await getAbhaProfile(accessToken, verifyUserObj.token);

    //                     if (abhaProfileData?.name) {

    //                         let dateofbirth =
    //                             abhaProfileData.dayOfBirth +
    //                             "-" +
    //                             abhaProfileData.monthOfBirth +
    //                             "-" +
    //                             abhaProfileData.yearOfBirth;

    //                         const base64Prefix = "data:image/png;base64,";
    //                         const base64String = abhaProfileData.profilePhoto
    //                             ? base64Prefix + abhaProfileData.profilePhoto
    //                             : abhaProfileData.kycPhoto
    //                                 ? base64Prefix + abhaProfileData.kycPhoto
    //                                 : (abhaProfileData.gender === 'M') ? '/images/male.svg' : (abhaProfileData.gender === 'F') ? '/images/female.svg' : 'Other';


    //                         const beneficiaryDetails = {
    //                             name: abhaProfileData.name,
    //                             abhaNo: maskNumber(abhaProfileData.ABHANumber),
    //                             originalabha: abhaProfileData.ABHANumber,
    //                             hid: abhaProfileData.ABHAProfile.preferredAbhaAddress,
    //                             hidn: abhaProfileData.ABHAProfile.ABHANumber,
    //                             address: abhaProfileData.address,
    //                             mobile: abhaProfileData.mobile.slice(0, -4).replace(/./g, "X") + abhaProfileData.mobile.slice(-4),
    //                             originalmobile: abhaProfileData.mobile,
    //                             dob: dateofbirth,
    //                             yearOfBirth: 'XX-XX-' + abhaProfileData.yearOfBirth,
    //                             gender: (abhaProfileData.gender === 'M') ? 'Male' : (abhaProfileData.gender === 'F') ? 'Female' : 'Other',
    //                             kycphoto: base64String
    //                         };

    //                         const orignalBeneficiaryData = {
    //                             distlgd: abhaProfileData.districtCode,
    //                             district_name: abhaProfileData.districtName,
    //                             dob: dateofbirth,
    //                             gender: abhaProfileData.gender,
    //                             fullgendername: (abhaProfileData.gender === 'M') ? 'Male' : (abhaProfileData.gender === 'F') ? 'Female' : 'Other',
    //                             hid: abhaProfileData.preferredAbhaAddress,
    //                             hidn: abhaProfileData.ABHANumber,
    //                             mobile: abhaProfileData.mobile,
    //                             name: abhaProfileData.name,
    //                             statename: abhaProfileData.stateName,
    //                             statelgd: abhaProfileData.stateCode,
    //                             address: abhaProfileData.address,
    //                             kycphoto: base64String
    //                         }
    //                         setBeneficiaryData(beneficiaryDetails);
    //                         localStorage.setItem("beneficiaryDetails", JSON.stringify(beneficiaryDetails));
    //                         localStorage.setItem("orignalBeneficiaryData", JSON.stringify(orignalBeneficiaryData));
    //                         setOtpModal(false);
    //                         setShowDataModal(true);
    //                         setIsLoading(false);
    //                     } else {
    //                         setErrorMessage(abhaProfileData.message);
    //                     }
    //                 }

    //             } else {
    //                 setErrorMessage(response.data.message);
    //                 setIsLoading(false);
    //             }
    //         }
    //     } catch (error) {
    //         setErrorMessage("Something went wrong!!");
    //         setIsLoading(false);
    //     } finally {
    //         //console.log('error');
    //     }
    // };

    // const verifyOtp = async (event) => {
    //     const Backend_token = localStorage.getItem('Backend_token');
    //     event.preventDefault();
    //     setIsLoading(true);
    //     try {
    //         const encryptedOtp = await encryptString(OtpText);
    //         if (encryptedOtp) {
    //             const response = await axios.post(
    //                 '/abdm/profileVerifyOtp',
    //                 {
    //                     request: {
    //                         "scope": [
    //                             "abha-login",
    //                             "aadhaar-verify"
    //                         ],
    //                         "authData": {
    //                             "authMethods": [
    //                                 "otp"
    //                             ],
    //                             "otp": {
    //                                 "txnId": txnId,
    //                                 "otpValue": encryptedOtp
    //                             }
    //                         }
    //                     },
    //                     header: {
    //                         'Content-Type': 'application/json',
    //                         'REQUEST-ID': uuidv4(),
    //                         'TIMESTAMP': new Date().toISOString(), // Generate the current timestamp dynamically
    //                         'Authorization': `Bearer ${accessToken}`,
    //                     },
    //                 },
    //                 {
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                         'Authorization': `Bearer ${Backend_token}`,
    //                     },
    //                 }
    //             );
    //             if (response.data?.token) {

    //                 // get ABHA profile data
    //                 const abhaProfileData = await getAbhaProfile(accessToken, response.data.token);
    //                 if (abhaProfileData?.name) {
    //                     let dateofbirth =
    //                         abhaProfileData.dayOfBirth +
    //                         "-" +
    //                         abhaProfileData.monthOfBirth +
    //                         "-" +
    //                         abhaProfileData.yearOfBirth;

    //                     const base64Prefix = "data:image/png;base64,";
    //                     const base64String = abhaProfileData.profilePhoto
    //                         ? base64Prefix + abhaProfileData.profilePhoto
    //                         : abhaProfileData.kycPhoto
    //                             ? base64Prefix + abhaProfileData.kycPhoto
    //                             : (abhaProfileData.gender === 'M') ? '/images/male.svg' : (abhaProfileData.gender === 'F') ? '/images/female.svg' : 'Other';

    //                     const beneficiaryDetails = {
    //                         name: abhaProfileData.name,
    //                         abhaNo: maskNumber(abhaProfileData.ABHANumber),
    //                         originalabha: abhaProfileData.ABHANumber,
    //                         hid: abhaProfileData.preferredAbhaAddress,
    //                         hidn: abhaProfileData.ABHANumber,
    //                         address: abhaProfileData.address,
    //                         mobile: abhaProfileData.mobile.slice(0, -4).replace(/./g, "X") + abhaProfileData.mobile.slice(-4),
    //                         originalmobile: abhaProfileData.mobile,
    //                         dob: dateofbirth,
    //                         yearOfBirth: 'XX-XX-' + abhaProfileData.yearOfBirth,
    //                         gender: (abhaProfileData.gender === 'M') ? 'Male' : (abhaProfileData.gender === 'F') ? 'Female' : 'Other',
    //                         kycphoto: base64String
    //                     };

    //                     const orignalBeneficiaryData = {
    //                         distlgd: abhaProfileData.districtCode,
    //                         district_name: abhaProfileData.districtName,
    //                         dob: dateofbirth,
    //                         gender: abhaProfileData.gender,
    //                         fullgendername: (abhaProfileData.gender === 'M') ? 'Male' : (abhaProfileData.gender === 'F') ? 'Female' : 'Other',
    //                         hid: abhaProfileData.preferredAbhaAddress,
    //                         hidn: abhaProfileData.ABHANumber,
    //                         mobile: abhaProfileData.mobile,
    //                         name: abhaProfileData.name,
    //                         statename: abhaProfileData.stateName,
    //                         statelgd: abhaProfileData.stateCode,
    //                         address: abhaProfileData.address,
    //                         kycphoto: base64String
    //                     }
    //                     setBeneficiaryData(beneficiaryDetails);
    //                     localStorage.setItem("beneficiaryDetails", JSON.stringify(beneficiaryDetails));
    //                     localStorage.setItem("orignalBeneficiaryData", JSON.stringify(orignalBeneficiaryData));
    //                     setOtpModal(false);
    //                     setShowDataModal(true);
    //                     setIsLoading(false);
    //                 } else {
    //                     setErrorMessage(abhaProfileData.message);
    //                 }
    //             } else {
    //                 setErrorMessage(response.data.message);
    //                 setIsLoading(false);
    //             }
    //         }
    //     } catch (error) {
    //         setErrorMessage("Something went wrong!!");
    //         setIsLoading(false);
    //     } finally {
    //         //console.log('error');
    //     }
    // };

    // ----------------------------------------Speedometer ------------------------
    const stats = [
        { label: t('generalFollowUp'), value: dashboardData?.enrolled_all || 0 },
        { label: t('lostToFollowUp'), value: dashboardData?.enrolled_30 || 0 },
        { label: t('cbac'), value: dashboardData?.cbac_completed || 0 },
        { label: t('referredNotReached'), value: dashboardData?.screened_first_time || 0 }
    ];

    // ------------------------------------------Speedometer-------------------

    return (
        <>

            {isPageLoading && <Loader />}

            <AbhaSendOtp showAbhaSendOtp={showAbhaSendOtp} closeSendOtpModal={closeSendOtpModal} setshowAbhaVerifyOtp={setshowAbhaVerifyOtp} setshowAbhaSendOtp={setshowAbhaSendOtp} setAbhaTxnId={setAbhaTxnId} />
            <AbhaVerifyOtp showAbhaVerifyOtp={showAbhaVerifyOtp} closeVerifyOtpModal={closeVerifyOtpModal} AbhaTxnId={AbhaTxnId} setshowAbhaVerifyOtp={setshowAbhaVerifyOtp} />
            {/* --------------------------Add benificry modal ---------------------------- */}
            {showModal && (
                <Addbenificerymodal closeAddBeneficiaryModal={() => setShowModal(false)} openModal={openModal} />
            )}

            <div className="page-dashboard py-3" style={{ position: 'relative', height: "100vh" }}>

                <div className="container-fluid">
                   
                    {/* {isExistBeneficiary && (
                        <div className="rediredt-btn">
                            <span>Please click to view/add the pending patient information without re-entering ABHA details.</span>
                            <button className="btn btn-primary" onClick={handleNavigateBeneficiary}>{t('dashboard.completeProcess')}</button>
                        </div>
                    )} */}

                    {localStorage.getItem("PMNDP_token") ? (
                        <>
                            <h2>{t('dashboard.title')}  <button className="addenterbtn" onClick={() => {
                                setAddbenificeryModal(true);
                            }}>
                                {t("dashboard.addBeneficiary")}
                            </button></h2>

                            <div className="row">

                                <div className="col-md-3 col-sm-12 col-12">
                                    <div className="outerborder pmndp-box-sd">
                                        <h5>{t("dashboard.totalPatients")}</h5>
                                        <h2 className="text-left">{pmndpDashboardData?.find(item => item.name === "Total Patient")?.count || 0}</h2>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-12 col-12">
                                    <div className="outerborder pmndp-box-sd">
                                        <h5>{t('dashboard.hemodialysisMachines')}</h5>
                                        <h2 className="text-left">{pmndpDashboardData?.find(item => item.name === "Total Machine")?.count || 0}</h2>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12 col-12">
                                    <div className="outerborder pmndp-box-sd">
                                        <h5>{t('dashboard.dialysisSessions')}</h5>
                                        <h2 className="text-left">{pmndpDashboardData?.find(item => item.name === "Total Dialysis")?.count || 0}</h2>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12 col-12">
                                    <div className="outerborder pmndp-box-sd">
                                        <h5>{t('dashboard.freshPatients')}</h5>
                                        <h2 className="text-left">{pmndpDashboardData?.find(item => item.name === "Total Fresh Patient")?.count || 0}</h2>
                                    </div>
                                </div>
                            </div>

                        </>
                    ) : (
                        <>
                            <h2>{t('dashboard.workPlan')}
                                <button
                                    className="addenterbtn"
                                    onClick={() => {
                                        setAddbenificeryModal(true);
                                    }}
                                    style={{
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.border = '2px solid #007bff';
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#007bff';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.border = '';
                                        e.target.style.backgroundColor = '';
                                        e.target.style.color = '';
                                    }}
                                >
                                    {t('dashboard.addBeneficiary')}
                                </button>
                            </h2>
                            <h5 style={{ textAlign: 'center', margin: '0 0 500px' }}>This page is under development.</h5>
                        </>
                    )}

                    {addbenificeryModal && (
                        <AbdmSection
                            addbenificeryModal={addbenificeryModal}
                            setAddbenificeryModal={setAddbenificeryModal}
                            openScannerModal={openScannerModal}
                            openSendOtpModal={openSendOtpModal}
                        />

                        // <div className="modal fade show d-block verificationModel" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                        //     <div className="modal-dialog modal-lg">
                        //         <div className="modal-content">
                        //             <div className="modal-header border-bottom-0 ">
                        //                 <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setAddbenificeryModal(false)} />
                        //             </div>
                        //             <div className="modal-body">
                        //                 <div className="row Abharow">
                        //                     <div className="col-md-6 text-center">
                        //                         <img src="/images/Abha.svg" alt="" className="abhaLogo" />
                        //                         <h2>{t("dashboard.add_beneficiary_button")}</h2>
                        //                     </div>
                        //                     <div className="col-md-6 text-left">
                        //                         <label className="header_text">Search ABHA ID:</label>
                        //                         <div style={{ margin: '7px 0 10px 0' }}>
                        //                             <label style={{ marginRight: '15px' }}>
                        //                                 <input
                        //                                     type="radio"
                        //                                     name="searchOption"
                        //                                     value="mobile"
                        //                                     style={{ marginRight: '5px' }}
                        //                                     onChange={handleRadioInput}
                        //                                     checked={searchBy === "mobile"}
                        //                                 />
                        //                                 Mobile No.
                        //                             </label>

                        //                             <label>
                        //                                 <input
                        //                                     type="radio"
                        //                                     name="searchOption"
                        //                                     value="abha"
                        //                                     style={{ marginRight: '5px' }}
                        //                                     onChange={handleRadioInput}
                        //                                     checked={searchBy === "abha"}
                        //                                 />
                        //                                 ABHA ID
                        //                             </label>
                        //                         </div>
                        //                         {errorMessage && (
                        //                             <p className="error-message-modal">{errorMessage}</p>
                        //                         )}
                        //                         {(searchBy === "mobile") && (
                        //                             <input
                        //                                 type="text"
                        //                                 name="abhano"
                        //                                 placeholder="Enter mobile no."
                        //                                 className="form-control"
                        //                                 maxLength="12" // Max length for the formatted value
                        //                                 value={displayValue}
                        //                                 autoComplete="off"
                        //                                 onChange={handleMobileChange}
                        //                             />
                        //                         )}
                        //                         {(searchBy === "abha") && (
                        //                             <input
                        //                                 type="text"
                        //                                 name="abhano"
                        //                                 placeholder="xx-xxxx-xxxx-xxxx"
                        //                                 className="form-control"
                        //                                 maxLength="18" // Max length for the formatted value
                        //                                 value={displayValue}
                        //                                 autoComplete="off"
                        //                                 onChange={handleInputChange}
                        //                             />
                        //                         )}

                        //                         <button
                        //                             className="abha-btn"
                        //                             onClick={openSendOtpModal}
                        //                         >
                        //                             Create ABHA
                        //                         </button>
                        //                         <div className="modal-buttonss">
                        //                             <button
                        //                                 className="btn btn btn-primary btn-prim border-0"
                        //                                 style={{
                        //                                     backgroundColor:
                        //                                         ((abhano.length === 14 && searchBy === 'abha') || (MobileNumber.length === 10 && searchBy === 'mobile')) ? "#3FC4F4" : "#A9A9A9", // Green when valid, Gray otherwise
                        //                                     color: "white",
                        //                                     marginRight: "10px",
                        //                                     transition: 'all 0.3s ease'
                        //                                 }}
                        //                                 onMouseEnter={(e) => {
                        //                                     if (!e.target.disabled) {
                        //                                         e.target.style.backgroundColor = 'transparent';
                        //                                         e.target.style.color = '#3FC4F4';
                        //                                         e.target.style.border = '2px solid #3FC4F4';
                        //                                     }
                        //                                 }}
                        //                                 onMouseLeave={(e) => {
                        //                                     if (!e.target.disabled) {
                        //                                         e.target.style.backgroundColor = ((abhano.length === 14 && searchBy === 'abha') || (MobileNumber.length === 10 && searchBy === 'mobile')) ? "#3FC4F4" : "#A9A9A9";
                        //                                         e.target.style.color = 'white';
                        //                                         e.target.style.border = '';
                        //                                     }
                        //                                 }}
                        //                                 onClick={handleSearch}
                        //                                 disabled={((abhano.length !== 14 && searchBy === 'abha') || (MobileNumber.length !== 10 && searchBy === 'mobile')) || isLoading}
                        //                             >
                        //                                 {isLoading ? "Processing.." : "OK"}
                        //                             </button>
                        //                             <button
                        //                                 className="btn btn-secondary btn-Secon border-0"
                        //                                 style={{
                        //                                     backgroundColor:
                        //                                         ((abhano.length === 14 && searchBy === 'abha') || (MobileNumber.length === 10 && searchBy === 'mobile')) ? "#F9A023" : "#A9A9A9", // Red when valid, Blue otherwise
                        //                                     color: "white",
                        //                                     transition: 'all 0.3s ease'
                        //                                 }}
                        //                                 onMouseEnter={(e) => {
                        //                                     if (!e.target.disabled) {
                        //                                         e.target.style.backgroundColor = 'transparent';
                        //                                         e.target.style.color = '#F9A023';
                        //                                         e.target.style.border = '2px solid #F9A023';
                        //                                     }
                        //                                 }}
                        //                                 onMouseLeave={(e) => {
                        //                                     if (!e.target.disabled) {
                        //                                         e.target.style.backgroundColor = ((abhano.length === 14 && searchBy === 'abha') || (MobileNumber.length === 10 && searchBy === 'mobile')) ? "#F9A023" : "#A9A9A9";
                        //                                         e.target.style.color = 'white';
                        //                                         e.target.style.border = '';
                        //                                     }
                        //                                 }}
                        //                                 type="reset"
                        //                                 onClick={() => { setabhano(""); setMobileNumber(""); setDisplayValue(""); }}
                        //                                 disabled={(abhano.length !== 14 && searchBy === 'abha') || (MobileNumber.length !== 10 && searchBy === 'mobile')}
                        //                             >
                        //                                 Reset
                        //                             </button>
                        //                         </div>
                        //                     </div>
                        //                 </div>
                        //                 <div className="orBenif">or</div>
                        //                 <button className="btn btn-secondary btn-Scan " onClick={openScannerModal} type="submit">
                        //                     <img src={"/images/Scanner.png"} alt="Scanner" className="" /> Scan ABHA QR Code
                        //                 </button>
                        //             </div>

                        //         </div>
                        //     </div>
                        // </div>
                    )}

                    <Modalqr show={showScannerModal} handleClose={closeScannerModal}>
                        {<QRCodeScanner isqrenabled={isqrenabled} setisqrenabled={setisqrenabled} />}
                    </Modalqr>

                    {/* First Modal: Enter Beneficiary Details */}

                    {/* {showOtpModal && (<div className="modal fade show d-block verificationModel addPatentModel1" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header border-bottom-0 ">

                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeOtpModal} />
                                </div>
                                <div className="modal-body">
                                    <div className="row Abharow">
                                        <div className="col-md-6 text-center">
                                            <img src="/images/Abha.svg" alt="" className="abhaLogo aaaa" />
                                            <h2>Enter OTP</h2>
                                        </div>
                                        <div className="col-md-6 text-left">
                                            <label className="header_text">Enter OTP:</label>
                                            {errorMessage && (
                                                <p className="error-message-modal">{errorMessage}</p>
                                            )}

                                            <div style={{ display: "flex", gap: "20px" }}>
                                                {Array.isArray(abdmAbhaOtp) &&
                                                    abdmAbhaOtp.map((value, index) => (
                                                        <input
                                                            key={index}
                                                            id={`botp-input-${index}`}
                                                            type="text"
                                                            maxLength="1"
                                                            name="abdmAbhaOtp"
                                                            value={value}
                                                            onChange={(e) => handleChange(e.target.value, index)}
                                                            onKeyDown={(e) => handleBackspace(e, index)}
                                                            className="form-control"
                                                            autoComplete="off"
                                                            style={{
                                                                flex: "1 1 calc(16.66% - 20px)", // 100% / 6 = 16.66%
                                                                maxWidth: "calc(16.66% - 20px)", // Ensure max width stays proportional
                                                                display: "flex",
                                                                flexDirection: "column", // Ensure the content inside the item is laid out vertically
                                                                alignItems: "flex-start", // Align items to the start
                                                                width: "auto", // Allow width to adjust automatically
                                                                height: "50px", // Set height as needed or use a fixed height if required
                                                                textAlign: "center", // Align text to the center
                                                                fontSize: "18px", // Font size for text
                                                            }}
                                                        />
                                                    ))}
                                            </div>

                                            <div className="modal-buttonss">
                                                <button
                                                    className="btn btn btn-primary btn-prim force-margin-left"
                                                    style={{
                                                        backgroundColor: Array.isArray(abdmAbhaOtp) && abdmAbhaOtp.every((val) => val !== "")
                                                            ? "#3FC4F4"
                                                            : "#A9A9A9",
                                                        color: "white",
                                                        marginRight: "10px",
                                                        marginLeft: "0 !important",
                                                    }}
                                                    onClick={(searchBy === 'mobile') ? verifyMobileOtp : verifyOtp}
                                                    disabled={
                                                        (Array.isArray(abdmAbhaOtp) && !abdmAbhaOtp.every((val) => val !== "")) || isLoading
                                                    }
                                                >
                                                    {isLoading ? "Processing..." : "Submit"}
                                                </button>

                                                <button
                                                    className="resent-enterBtn"
                                                    onClick={resendOtp}
                                                    disabled={resendTimer > 0}
                                                >
                                                    {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : "Resend OTP"}
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>)} */}

                    {/* {showDataModal && (
                        <div className="modal fade show d-block verificationModel addPatentModel" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header border-bottom-0 ">
                                        <div className="text-center headerText">
                                             <h5 className="modal-title" id="exampleModalLabel">Add Patient</h5> 
                                        </div>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeDataModal} />
                                    </div>
                                    <div className="modal-body">
                                        <div className="row header-modal">
                                            <div className="col-md-6 text-center">
                                                <img
                                                    src={beneficiaryData?.kycphoto}
                                                    alt=""
                                                    className="abhaLogo"
                                                />
                                                <h2>Beneficiary Details</h2>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="header_text">ABHA ID:</label>
                                                <input
                                                    type="text"
                                                    placeholder="xx-xxxx-xxxx-xxxx"
                                                    className="form-control"
                                                    readOnly
                                                    value={displayValue}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="row first_data">
                                            <div className="col-md-2 col-xs-12 col-12">
                                                <strong>Name:</strong>
                                                <p>{beneficiaryData?.name}</p>
                                            </div>
                                            <div className="col-md-3">
                                                <strong>ABHA No:</strong> <p>{beneficiaryData?.abhaNo}</p>
                                            </div>
                                            <div className="col-md-2">
                                                <strong>Date of Birth:</strong> <p>{beneficiaryData?.yearOfBirth}</p>
                                            </div>
                                            <div className="col-md-2">
                                                <strong>Gender:</strong> <p>{beneficiaryData?.gender}</p>
                                            </div>
                                            <div className="col-md-3">
                                                <strong>Mobile No:</strong> <p>{beneficiaryData?.mobile}</p>
                                            </div>
                                        </div>

                                        <div className="row second_data">
                                            <div className="col-md-6">
                                                <strong>Address:</strong> <p>{beneficiaryData?.address}</p>
                                            </div>
                                        </div>
                                        <div className="modal-buttons otp-footer">
                                            <button
                                                className="btn btn-primary btn-prii"
                                                onClick={handleRedirect}
                                            >
                                                OK
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    )} */}

                    {!localStorage.getItem("PMNDP_token") && (<>

                        {/* <div className="row bcakground-row bg_niksh">
                            <span className="header-container">
                                <img src={"/images/NCD1.png"} alt="NCD Logo" className="rchLogo" />
                                <h3 className="text_area">NCD</h3>
                            </span>
                            {stats.map((stat, index) => {
                                const labels = [t('ncd.enrolled'), t('ncd.enrolled30Plus'), t('ncd.cbac'), t('ncd.firstTimeScreening')];
                                const colors = ['#4f46e5', '#06b6d4', '#10b981', '#f59e0b'];
                                return (
                                    <div key={index} className="col-md-3 col-sm-6 col-6">
                                        <div className="outerborder">
                                            <h5>{labels[index]}</h5>
                                            <div className="modern-speedometer-only">
                                                <ModernSpeedometer
                                                    value={stat.value}
                                                    maxValue={1000}
                                                    title=""
                                                    unit=""
                                                    color={colors[index]}
                                                    size={150}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div> */}

                        {/* <NcdModernDashboard
                            dashboardData={dashboardData}
                            facilityType={JSON.parse(localStorage.getItem("NCD_loggedinUserdetails") || "{}")?.facilityType}
                            onRefresh={fetchDashboardData}
                        /> */}

                        {/* <div className="row bg_niksh niksh-section">
                            <span className="header-container">
                                <img src={"/images/NCD2.png"} alt="NCD Logo" className="rchLogo" />
                                <h3 className="text_area">{t('sickle.title')}</h3>
                            </span>
                            <SpeedometerCard label={t('sickle.sickleCellScreening')} value={60} />
                            <SpeedometerCard label={t('sickle.screeningTest')} value={40} />
                            <SpeedometerCard label={t('sickle.confirmatoryTest')} value={30} />
                            <SpeedometerCard label={t('sickle.patientsReferred')} value={20} />
                        </div> */}

                        {/* <div className="footer_div">
                            <div className="row benificery">
                                <h6 className="">{t('beneficiarySection.title')}</h6>

                                <BeneficiaryCard
                                    img={"/images/NCD1.png"}
                                    count='0'
                                    label={t('beneficiarySection.beneficiaries')}
                                    onClick={() => navigate("/beneficiary")}
                                />

                                <BeneficiaryCard
                                    img={"/images/NCD2.png"}
                                    count='0'
                                    label={t('beneficiarySection.beneficiaries')}
                                    onClick={() => navigate("/beneficiary")}
                                />
                            </div>
                        </div> */}
                    </>)}

                </div>

                <Footer />
            </div>
        </>
    );
};

